<template>
  <div id="app">
      <notifications group="mensagens" class="mt-2" />
      <router-view/>
      <FooterComponent></FooterComponent>
   </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent'
export default { 
  components: {
    FooterComponent
  }
}
</script>